webpackJsonp([35783957827783],{

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/line.13eb4d48.jpg";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _homeModule = __webpack_require__(296);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	var _line = __webpack_require__(456);
	
	var _line2 = _interopRequireDefault(_line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    var projects = data.allMarkdownRemark.edges;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-11 offset-0 ' + _homeModule2.default.Banner },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Creative studio specializing in machine learning',
	              _react2.default.createElement(
	                'span',
	                null,
	                '.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement('div', { className: 'offset-2 ' + _homeModule2.default.Subtitle })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        projects.map(function (_ref, i) {
	          var node = _ref.node;
	          return _react2.default.createElement(
	            'div',
	            { key: node.id, className: 'row ' + _homeModule2.default.Project, style: { background: 'rgb(' + (250 - i * 10) + ', ' + (250 - i * 10) + ', ' + (250 - i * 10) + ')' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-md-4 ' + _homeModule2.default.ProjectDescription },
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: node.frontmatter.path },
	                  node.frontmatter.title
	                )
	              ),
	              _react2.default.createElement('div', { className: _homeModule2.default.HorizontalLine }),
	              _react2.default.createElement(
	                'p',
	                null,
	                node.frontmatter.description
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: node.frontmatter.path },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'View Project'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-md-8  ' + _homeModule2.default.ProjectImage },
	              _react2.default.createElement('img', { src: node.frontmatter.thumbnail.publicURL })
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Banner":"src-pages-styles----home-module---Banner---1yR8w","Subtitle":"src-pages-styles----home-module---Subtitle---1VepU","VerticalLine":"src-pages-styles----home-module---VerticalLine---3WWLi","HorizontalLine":"src-pages-styles----home-module---HorizontalLine---2TzBh","Project":"src-pages-styles----home-module---Project---3MX6K","ProjectDescription":"src-pages-styles----home-module---ProjectDescription---1QpVP","ProjectImage":"src-pages-styles----home-module---ProjectImage---KYmV1","Match":"src-pages-styles----home-module---Match---1m7Ha"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-bdba2d893313d2b15b1f.js